function hideEmptyAccordions() {
  const productAccordions = document.querySelectorAll('.product__accordion');
  productAccordions.forEach((accordion) => {
    const content = accordion.querySelector('.accordion__content');
    if (content.innerHTML.trim() === '') {
      accordion.classList.add('hidden');
    }
  });
}

hideEmptyAccordions();